import { Card, CardContent, Typography, Divider, Box } from '@mui/material';
import Grid from '@mui/material/Grid';

interface DocumentData {
  mrn: string;
  status: string;
  facility: string;
  documentId: string;
  age?: string;
  gender?: string;
  payor?: string;
  dos: string;
}

const AuditDetailsCard = ({ documentData }: { documentData: DocumentData }) => {

  return (
    <Box sx={{ p: 3 }}>
        <Card 
            sx={{ 
                width: '100%',
                borderRadius: 2,
            }}
            variant='outlined'
        >
        <CardContent>
            <Typography 
            variant="h5" 
            gutterBottom 
            sx={{ 
                fontWeight: 'bold',
                mb: 2
            }}
            >
            Audit Details
            </Typography>
            
            <Divider sx={{ mb: 3 }} />
            
            <Grid container spacing={2}>
            {/* Column 1 */}
            <Grid item xs={12} sm={6} md={4}>
                <DetailItem label="MRN" value={documentData.mrn} />
                <DetailItem label="Status" value={documentData.status} />
                <DetailItem label="Age" value={documentData.age || 'N/A'} />
            </Grid>
            
            {/* Column 2 */}
            <Grid item xs={12} sm={6} md={4}>
                <DetailItem label="Facility" value={documentData.facility} />
                <DetailItem label="Document ID" value={documentData.documentId} />
                <DetailItem label="DOS" value={documentData.dos} />
            </Grid>
            
            {/* Column 3 */}
            <Grid item xs={12} sm={6} md={4}>            
                <DetailItem label="Gender" value={documentData.gender || 'N/A'} />
                <DetailItem label="Payor" value={documentData.payor || 'N/A'} />
                
            </Grid>
            </Grid>
        </CardContent>
        </Card>
    </Box>
  );
};

// Reusable component for each detail row
const DetailItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography 
        variant="subtitle2" 
        sx={{ 
          fontWeight: 'bold',
          color: 'text.secondary',
          fontSize: '0.75rem'
        }}
      >
        {label}
      </Typography>
      <Typography 
        variant="body1"
        sx={{
          fontWeight: 500,
          wordBreak: 'break-word'
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default AuditDetailsCard;